/** React */
import React, {
  HtmlHTMLAttributes,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

/** CSS */
import "./index.css";
import clsx from "clsx";

/** Icons */
import { TfiAngleUp, TfiAngleDown } from "react-icons/tfi";

/** Hook */
import { useMenu } from "./menu-root";
import { Anchor } from "../button";

/** Props */
type Props = HtmlHTMLAttributes<HTMLDivElement> & {
  anchor?: React.AnchorHTMLAttributes<HTMLAnchorElement> & { Custom?: React.ComponentClass<any>;}
  children: ReactNode;
  buttonClassName?: string;
  nested?: boolean;
  subnested?: boolean;
  dropdown?: boolean;
  isLink?: boolean;
  isSelected?: boolean;
  handleCallbackClick?: () => void;
  "data-menu-id"?: string;
};

export function MenuButton({
  anchor,
  children,
  buttonClassName,
  nested,
  subnested,
  dropdown,
  isLink,
  isSelected,
  handleCallbackClick,
  ...props
}: Props) {
  const { toggle } = useContext(useMenu());
  const [isToggled, setIsToggled] = useState(false);
  const menuId = useMemo(() => props["data-menu-id"], [props]);

  const handleClick = () => {
    toggle(menuId as string);
    setIsToggled(!isToggled);

    handleCallbackClick && handleCallbackClick();
  };

  return anchor ? (
    <Anchor
      className={clsx(
        "menu-button",
        {
          "menu-button-dropdown": dropdown,
          "menu-button-nested": nested,
          "menu-button-subnested": subnested,
          "menu-button-is-link": isLink,
          "menu-button-is-selected": isSelected,
        },
        buttonClassName
      )}
      {...(anchor as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
    >
      {children}
      {dropdown ? (
        isToggled ? (
          <TfiAngleDown size="1rem" />
        ) : (
          <TfiAngleUp size="1rem" />
        )
      ) : null}
    </Anchor>
  ) : (
    <div
      role="button"
      className={clsx(
        "menu-button",
        {
          "menu-button-dropdown": dropdown,
          "menu-button-nested": nested,
          "menu-button-subnested": subnested,
          "menu-button-is-link": isLink,
          "menu-button-is-selected": isSelected,
        },
        buttonClassName
      )}
      onClick={handleClick}
      {...props}
    >
      {children}
      {dropdown ? (
        isToggled ? (
          <TfiAngleDown size="1rem" />
        ) : (
          <TfiAngleUp size="1rem" />
        )
      ) : null}
    </div>
  );
}
